import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const ReportIcon = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.5 19V4H7.5V5H11.2071L13.2071 7H18.0625V15.875H12.7929L10.7929 13.875H7.5V19H6.5ZM7.5 12.875H11.2071L13.2071 14.875H17.0625V8H12.7929L10.7929 6H7.5V12.875Z"
      fill="currentColor"
    />
  </svg>,
  'Report'
);
